import { appAlert } from '@/lib/appAlert';
import { Ionicons } from '@expo/vector-icons';
import { useTranslation } from 'react-i18next';
import { Pressable, StyleSheet, Text } from 'react-native';

import { fontSize, radius, spacing } from '@/constants/theme';

/**
 * Σήμα «Παρέχει Υπηρεσίες 💼».
 * `compact` = μόνο εικονίδιο (για λίστες), αλλιώς εικονίδιο + κείμενο.
 */
export function ProviderBadge({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();

  function explain() {
    appAlert(
      t('providerBadge.alert_title'),
      t('providerBadge.alert_body'),
    );
  }

  if (compact) {
    return (
      <Pressable onPress={explain} hitSlop={8} accessibilityRole="button" accessibilityLabel={t('providerBadge.alert_title')}>
        <Ionicons name="briefcase" size={15} color="#059669" />
      </Pressable>
    );
  }
  return (
    <Pressable style={styles.badge} onPress={explain} accessibilityRole="button">
      <Ionicons name="briefcase" size={13} color="#059669" />
      <Text style={styles.text}>{t('profile.providesBadge')}</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    alignSelf: 'flex-start',
    backgroundColor: '#ECFDF5',
    borderRadius: radius.full,
    borderWidth: 1,
    borderColor: '#6EE7B7',
    paddingVertical: 3,
    paddingHorizontal: spacing.sm,
  },
  text: {
    color: '#059669',
    fontSize: fontSize.sm,
    fontWeight: '700',
  },
});
